import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinRuleEditAggregateTriggers',
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    states: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    stateMetricRule() {
      return [v => this.rule.properties.timeTriggerOnly || !!v && !this.rule.properties.stateMetrics.find(m => parseInt(m.stateId) === parseInt(v)) || this.$i18n_t('Error.DTWINSSTATES_CANNOT_USE_METRIC_AS_AGGTRIGGER')];
    }
  },
  watch: {
    rule() {
      this.processAggregates();
    }
  },
  mounted() {
    this.processAggregates();
  },
  methods: {
    stateTitle(stateObj) {
      const state = this.states.find(s => s.id === stateObj.stateId);
      if (state) {
        return state.properties.title;
      }
      return undefined;
    },
    processAggregates() {
      // change boolean values to string "true"/"false"
      // so they are selectable in the v-select
      // the XAPI offers/changes these trigger-values to proper booleans, but the v-select only has string-values
      // this part maps everything back - the rule-trigger handles both cases anyway, and the XAPI maps them back to boolean
      const conditionsDisabled = this.rule.properties.conditionEnabled === false || this.rule.properties.timeTriggerOnly;
      this.rule.properties.triggeredAggregates.forEach(agg => {
        agg.triggerValue = conditionsDisabled ? 'true' : `${agg.triggerValue || true}`.toLowerCase();
      });
    },
    openDigitalTwinOfState(bindingId) {
      window.open(`#${this.$router.currentRoute.path}?stateId=${bindingId}`, '_blank');
    }
  }
};